import styled from 'styled-components';
import loginBackground from '~/assets/images/back.png';
import CloudImg from '~/assets/images/cloud.svg';

export const LoginStyled = styled.div`
  width: 100%;
  height: 100vh;
  background: url(${loginBackground}) no-repeat padding-box;
  background-position: -10px -10px;
  background-size: 102% 102%;
  padding-top: 50px;
`;

export const CloudStyled = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  &::before {
    content: '';
    position: absolute;
    left: -25vw;
    top: -67vh;
    right: -55vw;
    bottom: -40vh;
    background-image: url(${CloudImg});
    background-size: cover;
    background-position: center center;
  }
`;
